// src/anchor.ts
var anchorType = /* @__PURE__ */ ((anchorType2) => {
  anchorType2["CENTER"] = "center";
  anchorType2["TOP"] = "top";
  anchorType2["TOP-LEFT"] = "top-left";
  anchorType2["TOP-RIGHT"] = "top-right";
  anchorType2["BOTTOM"] = "bottom";
  anchorType2["BOTTOM-LEFT"] = "bottom-left";
  anchorType2["BOTTOM-RIGHT"] = "bottom-right";
  anchorType2["LEFT"] = "left";
  anchorType2["RIGHT"] = "right";
  return anchorType2;
})(anchorType || {});
var anchorTranslate = {
  center: "translate(-50%,-50%)",
  top: "translate(-50%,0)",
  "top-left": "translate(0,0)",
  "top-right": "translate(-100%,0)",
  bottom: "translate(-50%,-100%)",
  "bottom-left": "translate(0,-100%)",
  "bottom-right": "translate(-100%,-100%)",
  left: "translate(0,-50%)",
  right: "translate(-100%,-50%)"
};
function applyAnchorClass(element, anchor, prefix) {
  const classList = element.classList;
  for (const key in anchorTranslate) {
    if (anchorTranslate.hasOwnProperty(key)) {
      classList.remove(`l7-${prefix}-anchor-${key}`);
    }
  }
  classList.add(`l7-${prefix}-anchor-${anchor}`);
}
export {
  anchorTranslate,
  anchorType,
  applyAnchorClass
};
